import { render, staticRenderFns } from "./ComissaoContainer.vue?vue&type=template&id=70794742&scoped=true"
import script from "./ComissaoContainer.vue?vue&type=script&lang=js"
export * from "./ComissaoContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70794742",
  null
  
)

export default component.exports